export default "__VITE_ASSET__DSNhwoyo__"